// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__jU-0h","name":"Header_name__9ad-C","birthday":"Header_birthday__2Zodt","skeleton":"Header_skeleton__ClSUk"};